import React from 'react';
import StaticPage, { Section, CardGrid } from './StaticPage';

export default function Press() {
  return (
    <StaticPage title="Press & Media" subtitle="News, announcements, and media resources from RentalX.">
      <Section title="About RentalX">
        <p>RentalX is Australia's leading student accommodation marketplace, connecting over 50,000 students with verified landlords across all major Australian university cities. Founded in Melbourne, we make it easy for domestic and international students to find safe, affordable housing from anywhere in the world.</p>
      </Section>

      <Section title="Recent News">
        <CardGrid items={[
          { title: 'RentalX Expands to Perth and Adelaide (Feb 2026)', desc: 'We\'re proud to announce our expansion to two new cities, giving students at Curtin, UWA, University of Adelaide and UniSA access to hundreds of new verified listings.' },
          { title: 'RentalX Raises A$5M Seed Round (Dec 2025)', desc: 'We closed our seed round led by Blackbird Ventures to accelerate platform growth and international student outreach.' },
          { title: 'Partnership with University of Melbourne (Oct 2025)', desc: 'RentalX is now the official off-campus housing partner for UniMelb, giving students direct access to verified listings from the student portal.' },
          { title: 'RentalX Launches Landlord Verification Program (Aug 2025)', desc: 'Our new landlord verification badge gives students extra confidence when browsing listings.' },
        ]} />
      </Section>

      <Section title="Media Kit">
        <p>Download our official logos, brand guidelines, and product screenshots for editorial use. Please do not alter our logo or use it in a misleading context.</p>
        <p className="mt-2"><strong>Media contact:</strong> press@rentalx.com.au | +61 3 9000 0001</p>
      </Section>

      <Section title="Appearances">
        <ul className="list-disc list-inside space-y-2">
          <li>The Australian Financial Review — "The startups making student life easier"</li>
          <li>ABC News — "International students turn to apps to find housing before they arrive"</li>
          <li>StartupSmart — "RentalX closes A$5M to solve Australia's student housing crisis"</li>
        </ul>
      </Section>
    </StaticPage>
  );
}
